import { searchCreatorPendingAtom } from '@/features/discovery/stores/mutation-atom';
import { selectCommonality, type SelectCommonalityRequest } from '../api';
import { useAbortableMutation } from '@/shared/hooks/use-abortable-mutation';

type SelectCommonalityMutationRequest = {
  discoverySessionId: string;
  request: SelectCommonalityRequest;
};

export function useSelectCommonality() {
  return useAbortableMutation({
    mutationFn: ({ discoverySessionId, request }: SelectCommonalityMutationRequest, signal) =>
      selectCommonality(discoverySessionId, request, signal),
    scope: { id: 'discovery:chat' },
    pendingAtom: searchCreatorPendingAtom,
    requestKey: 'discovery:select-commonality',
  });
}
